import { gsap } from "gsap";
import SplitText from "../gsap/SplitText.min";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray(".page-header__content h1, .page-header__content h2 ,.page-header__content h3").forEach(function(elem) {
    const splitTimeline = gsap.timeline({scrollTrigger: {
            trigger: elem,
            start: "top 85%",
            end: "top 85%",
            onToggle: self => gsap.to(elem, {opacity: self.isActive ? 1 : 0}),
            markers: false,
        }
    });

    const splitTitle = new SplitText(elem, {type: "words, lines"});
    splitTimeline.from(splitTitle.words, {duration: .4, delay: .5, opacity: 0, y: 100, stagger: 0.1, ease: "easeInOut", overwrite: "auto"});
});

gsap.utils.toArray("section h1, section h2:not(.post-cards__card h2)").forEach(function(elem) {
    const splitTimeline = gsap.timeline({scrollTrigger: {
            trigger: elem,
            start: "top 85%",
            end: "top 85%",
            onToggle: self => gsap.to(elem, {opacity: self.isActive ? 1 : 0}),
            markers: false,
        }
    });

    const splitTitle = new SplitText(elem, {type: "words, lines"});
    splitTimeline.from(splitTitle.lines, {duration: .4, delay: 0, opacity: 0, y: 50, stagger: 0.1, ease: "easeInOut", overwrite: "auto"});
});

gsap.to(".page-header__content", {
    trigger: ".page-header",
    css: { visibility: 'visible' }
});

gsap.from(".animate-content", {
    trigger: ".page-header",
    y: 100,
    duration: .4,
    opacity: 0,
    delay: 1
});

gsap.from(".breadcrumbs", {
    trigger: ".page-header",
    y: 10,
    duration: .6,
    opacity: 0,
    delay: 1
});

gsap.from(".advice-cta", {
    trigger: ".page-header",
    y: 100,
    duration: .6,
    opacity: 0,
    delay: 1
});

gsap.from(".advice-cta__button", {
    trigger: ".page-header",
    y: -100,
    duration: .1,
    delay: 1.5
});

gsap.from(".footer-cta", {
    scrollTrigger: {
        trigger: ".footer",
        start: 'top 80%',
        markers: false,
    },
    y: 60,
    duration: .4,
    opacity: 0,
    delay: 0,
});

const tlButton = gsap.timeline({
    scrollTrigger: {
        trigger: ".footer",
        start: 'top 80%',
        markers: false
    }
});

tlButton.to(".footer-cta-button", {scale: 1.1, duration: .3, delay: 1,});
tlButton.to(".footer-cta-button", {scale: 0.95, duration: .3,});
tlButton.to(".footer-cta-button", {scale: 1.05, duration: .3,});
tlButton.to(".footer-cta-button", {scale: 1, duration: .3,});
tlButton.to(".footer-cta-button", {scale: 1.1, duration: .3, delay: 1,});
tlButton.to(".footer-cta-button", {scale: 0.95, duration: .3,});
tlButton.to(".footer-cta-button", {scale: 1.05, duration: .3,});
tlButton.to(".footer-cta-button", {scale: 1, duration: .3,});